import {sendNotifications} from "../../services/api";
import {SEND_MESSAGE, SEND_MESSAGE_FAIL} from "../message/actions/actionTypes";
import api from '../../services/instanceapi'
import {checkErrorMessage} from "../../utils/utils";

export const sendOneNotifications = (id, message) => async (dispatch) => {

    try {
        const notification = await api.post(sendNotifications(id), message)
        dispatch({
            type: SEND_MESSAGE,
            payload: {
                message: notification.status
            }
        })
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: SEND_MESSAGE_FAIL,
                payload: {
                    message: message
                },
            });
        }
        return Promise.reject()
    }
}